import { style } from 'typestyle'
export const fw400 = style({ fontWeight: 400 })
